export default class SessionCore {
	// session 统一前缀
	private static readonly sessionPrefix: string = 'SafeRedirect_';
	/**
	 * 获取 session 值
	 * @param key 键名
	 */
	static getItem (key: string): any {
		let res: any;
		if (!key) return res;
		const sessionKey: string = this.sessionPrefix + key;
		try {
			let data: string = window.sessionStorage.getItem(sessionKey) || '';
			res = JSON.parse(data);
		} catch (err) {
			res = null;
		}
		return res;
	}
	/**
	 * 设置 session
	 * @param key 键名
	 * @param value 值
	 */
	static setItem (key: string, value: any): void {
		if (!key) return;
		const sessionKey: string = this.sessionPrefix + key;
		try {
			window.sessionStorage.setItem(sessionKey, JSON.stringify(value));
		} catch (err) {
			console.log(err);
		}
	}
	/**
	 * 校验 session 是否已存在
	 * @param key 键名
	 */
	static checkIsExist (key: string): boolean {
		const res: any = this.getItem(key);
		return res !== null;
	}
	/**
	 * 获取 url 堆栈信息
	 * @param path 页面 url path
	 */
	static getStackInfo (path: string): Record<string, any>[] {
		const sessionKey: string = `${path}_urlStackInfo`;
		return this.getItem(sessionKey) || [];
	}
	/**
	 * 设置 url 堆栈信息，单个 path 最多保留 10 条信息
	 * @param path 页面 url path
	 * @param urlStackInfo url 堆栈信息列表
	 */
	static setStackInfo (path: string, urlStackInfo: Record<string, any>[]): void {
		const length: number = urlStackInfo.length;
		const sessionKey: string = `${path}_urlStackInfo`;
		let _urlStackInfo: Record<string, any>[] = urlStackInfo;
		if (length > 10) _urlStackInfo = _urlStackInfo.slice(length - 10);
		this.setItem(sessionKey, _urlStackInfo);
	}
	/**
	 * 添加当前 url 堆栈信息
	 * @param path 页面 url path
	 * @param currentStackInfo 当前 url 堆栈信息
	 */
	static addCurrentStackInfo (path: string, currentStackInfo: Record<string, any>): void {
		let urlStackInfo: Record<string, any>[] = this.getStackInfo(path);
		urlStackInfo.push(currentStackInfo);
		this.setStackInfo(path, urlStackInfo);
	}
	/**
	 * 获取当前 url 堆栈信息
	 * @param path 页面 url path
	 */
	static getCurrentStackInfo(path: string): Record<string, any> {
		let urlStackInfo: Record<string, any>[] = this.getStackInfo(path);
		return urlStackInfo[urlStackInfo.length - 1] || {};
	}
	/**
	 * 更新当前 url 堆栈信息
	 * @param path 页面 url path
	 * @param currentStackInfo 当前 url 堆栈信息
	 */
	static refreshCurrentStackInfo (path: string, currentStackInfo: Record<string, any>): void {
		let urlStackInfo: Record<string, any>[] = this.getStackInfo(path);
		let length: number = urlStackInfo.length;
		if (!length) return;
		urlStackInfo[length - 1] = currentStackInfo;
		this.setStackInfo(path, urlStackInfo);
	}
	static clearStackInfo (path: string): void {
		this.setStackInfo(path, []);
	}
}
